import { createStore } from "@tanstack/store"
import { registerSessionCleanup } from "@/shared/lib/auth"

type MonsterPromoState = {
	open: boolean
}

const monsterPromoStore = createStore<MonsterPromoState>({ open: false })

export function showMonsterPromo(): void {
	monsterPromoStore.setState((state) => ({ ...state, open: true }))
}

export function setMonsterPromoOpen(open: boolean): void {
	monsterPromoStore.setState((state) => ({ ...state, open }))
}

export { monsterPromoStore }

registerSessionCleanup(() => setMonsterPromoOpen(false))
